import enumLoader from '../../mixins/data/init'

const state = {
  enums: null,
}

const mutations = {
  SET_ENUMS(state, enums) {
    state.enums = enums
  },
}

const actions = {
  loadEnums(context) {
    enumLoader()
      .then(([enums]) => {
        console.log('系统枚举加载成功。')
        context.commit('SET_ENUMS', enums)
      })
      .catch(err => {
        console.error(err.message)
        context.commit('SET_ENUMS', null)
      })
  },
}

export default {
  state,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/enum.js